define(["exports", "@babel/runtime/helpers/esm/extends", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "styled-components", "../../themes"], function (_exports, _extends2, _objectWithoutPropertiesLoose2, _react, _styledComponents, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);
  var _excluded = ["icon", "placeholder"];

  var InputAreaStyled = _styledComponents.default.textarea.withConfig({
    displayName: "TextArea__InputAreaStyled",
    componentId: "sc-tbtqnw-0"
  })(["border:solid 1px ", ";border-radius:2px;color:", ";font-size:1.4em;font-weight:", ";line-height:22px;outline:none;padding:8px 16px;transition:", ";width:100%;&::placeholder{color:", ";font-weight:", ";}&:focus,&:hover{", "}", " ", ""], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.gray;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.dark;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.font.semibold;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return "border 0.4s " + theme.easing.ease + ", box-shadow 0.2s " + theme.easing.ease;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.darkGray;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.font.regular;
  }, _themes.focusBoxShadow, function (_ref7) {
    var disabled = _ref7.disabled;
    return disabled && (0, _styledComponents.css)(["background-color:", ";cursor:not-allowed;"], function (_ref8) {
      var theme = _ref8.theme;
      return theme.colors.lightGray;
    });
  }, function (_ref9) {
    var error = _ref9.error;
    return error && (0, _styledComponents.css)(["border-color:", ";&:focus,&:hover{border:solid 1px ", ";box-shadow:0 0 3px 0 ", ";outline:none;}"], function (_ref10) {
      var theme = _ref10.theme;
      return theme.colors.red;
    }, function (_ref11) {
      var theme = _ref11.theme;
      return theme.colors.red;
    }, function (_ref12) {
      var theme = _ref12.theme;
      return theme.colors.red;
    });
  });

  var LabelWithIcon = _styledComponents.default.label.withConfig({
    displayName: "TextArea__LabelWithIcon",
    componentId: "sc-tbtqnw-1"
  })(["display:block;position:relative;box-icon{display:block;fill:", ";height:18px;left:16px;position:absolute;top:50%;transform:translateY(-50%);width:18px;}input{padding:8px 16px 8px 40px;}"], function (_ref13) {
    var theme = _ref13.theme;
    return theme.colors.darkGray;
  });

  var TextArea = function TextArea(_ref14) {
    var icon = _ref14.icon,
        placeholder = _ref14.placeholder,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref14, _excluded);
    return icon ? /*#__PURE__*/_react.default.createElement(LabelWithIcon, rest, /*#__PURE__*/_react.default.createElement("box-icon", {
      name: icon.name,
      type: icon.type
    }), /*#__PURE__*/_react.default.createElement(InputAreaStyled, (0, _extends2.default)({
      type: "text",
      placeholder: placeholder
    }, rest))) : /*#__PURE__*/_react.default.createElement("label", rest, /*#__PURE__*/_react.default.createElement(InputAreaStyled, (0, _extends2.default)({
      type: "text",
      placeholder: placeholder
    }, rest)));
  };

  var _default = TextArea;
  _exports.default = _default;
});